import axios from 'axios';
import { BASE_API, CONFIG_ID } from 'constants/env';

const APP_CONFIG_URL = `${BASE_API}/api/configs/${CONFIG_ID}/web/`;

export const getAppConfig = () => axios.get(APP_CONFIG_URL).then((response) => response.data);
